import { graphql } from '../../../graphql/generated';

export const PERIODIC_GROUPS_QUERY = graphql(`
  query PeriodicGroups($labId: ID!) {
    labPeriodicGroups(labId: $labId) {
      id
      name
      maxCount
      period
    }
  }
`);
